export const contactContent = {
  sectionLabel: "Contact", // Título pequeño amarillo (reutilizable)
  title: "Contact Info", // Título principal en blanco
  company: "Hungerford Consulting",
  description: "Monday – Friday, 9am – 5pm (Eastern Time)",
  email: "daniel@hungerfordconsulting.com",
  phone: "+1 647 807 0133",
  scheduleLink:
    "https://api.leadconnectorhq.com/widget/booking/pvSPIagh7QDeGS6U9rxB",
};
